import { inputs } from './inputs';
import { buttons } from './buttons';

export const commonPopupStyle = (css) => css`
  :host {
     --last-h2-margin:6rem;
     --popup-text-align:left;
     text-align: var(--popup-text-align, center);
     outline: none !important;
    }
  h1 {
    font-size: 3.33rem;
    color: var(--c-font-title);
    font-weight: 400;
    margin: 1rem 0px;
  }
  h2 {
    font-size: 2.22rem;
    color: var(--c-text-sec);
    font-weight: 400;
    margin: 0;
  }
  h3 {
    font-size: 2rem;
    color: var(--c-text);
    font-weight: 500;
    margin: 1rem 0px;
  }
  p {
    font-size: 2rem;
    color: var(--c-text);
    font-weight: 400;
    margin: 0;
  }
  
  *::-webkit-scrollbar {
    width: 1rem;
    height: 1rem;
  }
  *::-webkit-scrollbar-track {
    border-radius: 16px;
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    border-radius: 16px;
    background: rgba(193, 193, 193, 0.52);
  }

  .grid-container {
   display: grid;
 }

 .col-3{
   margin:auto;
 }

  @media screen and  (max-width: 390px) {
    .title,.sub-title,.message{}
  }
  `;
export const commonPopupDesktopStyle = (css) => css`
   :host {
   --popup-text-align:left;
   text-align:left;
   --message-max-width: 44.25rem;
   --c-bg-sec:white;
  outline: none !important;

 }

 /* GRID */

 .grid-container {
   display: grid;
   grid-template-columns: max-content max-content;
 }

 .col-1 {
   text-align: left;
   place-self: center;
 }

 .col-2 {
   display: grid;
   padding: var(--message-padding, 0 5.5rem);
 }

 .one-line-grid {
   display: grid;
   grid-template-columns: 1fr 1fr;
   place-self: center start;
   gap: 2rem;
 }
 
 .one-line-grid-end {
   display: grid;
   place-self: end start;
   gap: 2rem;
 } 

 .end-start {
   place-self: end start;
 }
 
 .top-padding {
   padding: 3rem 0 0;
 }

 .center {
   text-align: center;
 }

 .padding-3 {
   padding: 3rem;
 }

 h2 {
   font-size: 3rem;
   font-weight: 700;
   margin-top: 3rem;
   margin-bottom: 2rem;
   font-family: Satoshi;
   font-weight: bold;
   line-height: 4rem;
   display: flex;
   align-items: center;
   text-align: center;
   color: var(--c-text-sub);
 }

 /* POPUPS */

  .about-popup{
   --popup-place-self: center;
 }

 .survey-complete-popup {
   --backdrop: url('./assets/waters.svg'), #f5f6f9;
   --background-position: bottom;
   --background-repeat: no-repeat;
   --background-size: unset;
   --position: relative;
   --popup-padding: 8rem;
 }

 .non-eligible-popup-type-2 {
  max-width: initial;
   --backdrop: url('./assets/waters.svg'), #f5f6f9;
   --background-position: bottom;
   --background-repeat: no-repeat;
   --background-size: unset;
   --position: relative;
   --popup-padding: 8rem;
   --message-padding: 0;
   --wrapper-width: 124rem;
   --close-btn-background: rgb(255 255 255 / 70%);
 }

 .before-exit-popup {
   --backdrop: url('./assets/waters.svg'), #f5f6f9;
   --background-position: bottom;
   --background-repeat: no-repeat;
   --background-size: unset;
   --position: relative;
   --wrapper-width: 90%;
 }

 .non-eligible-popup {
   --backdrop: url('./assets/waters.svg'), #f5f6f9;
   --background-position: bottom;
   --background-repeat: no-repeat;
   --background-size: unset;
   --position: relative;
   --wrapper-width: 90%;
 }
 .non-eligible-popup-add-boat {
   --backdrop: url('./assets/waters.svg'), #f5f6f9;
   --background-position: bottom;
   --background-repeat: no-repeat;
   --background-size: unset;
   --position: relative;
   --wrapper-width: 90%;
 }

 .non-eligible-popup-instanda {
   --wrapper-width: 100%;
   --backdrop: url('./assets/waters.svg'), #f5f6f9;
   --art-display: none;
   --height: 29rem;
   --background-position: bottom;
   --background-repeat: no-repeat;
   --background-size: unset;
   --position: relative;
 }

 .payment-terms-and-conditions-popup{
 }

 .lh-attestation-error-popup{
   --c-text-sub:#0D2D5F;
   --c-text:#121213;
 }

 .align-self-flex-start{
  align-self:flex-start;
  margin-inline-start:2rem;
 }
 
 .welcome-login-new-user-popup {
   max-width: initial;
   --position: relative;
 }

 .welcome-new-user-popup {
   max-width: initial;
   --position: relative;
 }
 
 .welcome-existing-user-popup {
   max-width: initial;
   --position: relative;
  }
  
 .survey-complete-popup {
    max-width: initial;
  }

 .package-selection-popup {
    --wrapper-width: 100%;
    --position: relative;
  }
 .boat-details-buy-now-error-popup {
    --wrapper-width: 100%;
    --position: relative;
  }
 .boat-details-min-buy-now-error-popup {
    --wrapper-width: 100%;
    --position: relative;
  }
 .boat-details-value-warning-popup {
    --wrapper-width: 100%;
    --position: relative;
  }
 .boat-details-min-value-warning-popup {
    --wrapper-width: 100%;
    --position: relative;
  }
 .package-selection-email-success-popup {
    --wrapper-width: 100%;
    --position: relative;
  }
 .package-selection-email-fail-popup {
    --wrapper-width: 100%;
    --position: relative;
  }

  .lh-attestation-error-popup {
    --wrapper-width: 100%;
    --position: relative;
  }

  .non-eligible-popup-instanda-artr {
    position: absolute;
    width: 340px;
    z-index: 1;
    right: 0;
    top: 10rem;
    height: 412px;
    width: -webkit-fill-available;
    background-image: url(./assets/clouds_r.svg);
    background-position: center right;
    background-repeat: no-repeat;
  }
  
  .non-eligible-popup-instanda-artl {
    position: absolute;
    width: 418px;
    z-index: 1;
    left: 0;
    top: 13rem;
    height: 403px;
    width: -webkit-fill-available;
    background-image: url(./assets/clouds_l.svg);
    background-position: center left;
    background-repeat: no-repeat;
  }

/* POPUP IMG SVG */  

  .lh-attestation-error-popup svg{
    max-height:45.5rem;
    max-width:32.5rem;
  }

  .package-selection-popup-div svg{
    height:27.5rem;
    width:27.5rem;
  }
  .boat-details-buy-now-error-popup-div svg{
    height:27.5rem;
    width:27.5rem;
  }
  .boat-details-min-buy-now-error-popup-div svg{
    height:27.5rem;
    width:27.5rem;
  }
  .boat-details-value-warning-popup-div svg{
    height:27.5rem;
    width:27.5rem;
  }
  .boat-details-min-value-warning-popup-div svg{
    height:27.5rem;
    width:27.5rem;
  }
  .package-selection-email-success-popup-div svg{
    height:27.5rem;
    width:27.5rem;
  }
  .package-selection-email-fail-popup-div svg{
    height:27.5rem;
    width:27.5rem;
  }

  .welcome-login-no-user-popup svg,
  .welcome-login-no-user-popup img {
    max-height: 28.25rem;
    max-width: 25rem;
  }

  .welcome-new-user-popup svg {
    max-height: 32rem;
    max-width: 26.6rem;
  }
  
  .welcome-existing-user-popup svg {
   max-height: 32rem;
   max-width: 26.6rem;
 }

 .before-exit-popup img,
 .before-exit-popup svg {
   max-height: 31rem;
   max-width: 26.5rem;
   margin-block:4rem;
 }

 .non-eligible-popup img,
 .non-eligible-popup svg {
   max-height: 31.25rem;
   max-width: 25.875rem;
 }
 .non-eligible-popup-add-boat img,
 .non-eligible-popup-add-boat svg {
   max-height: 31.25rem;
   max-width: 25.875rem;
 }

 .non-eligible-popup-instanda svg,
 .non-eligible-popup-instanda img {
   max-height: 31.25rem;
   max-width: 25.875rem;
 }

 .non-eligible-popup-type-2 svg {
   max-height: 36rem;
   max-width: 39rem;
 }

 /* WRAPPER */
 
 #wrapper.height-box {
   overflow: auto;
   height: auto;
 }

 #wrapper.width-box {
   max-width: var(--wrapper-width, 50%);
   height: fit-content;
 }

 /* OTHER */

 .section {
   min-width: 45vw;
 }

 *::-webkit-scrollbar {
   width: 1rem;
   height: 1rem;
 }

 *::-webkit-scrollbar-track {
   border-radius: 16px;
   background: transparent;
 }

 *::-webkit-scrollbar-thumb {
   border-radius: 16px;
   background: rgba(193, 193, 193, 0.52);
 }

 .hide {
   display: none;
 }

 .show {
   font-size: 2.5rem;
   border: none;
   padding: 0.5rem 2rem;
 }
`;
export const commonPopupMobileStyle = (css) => css`
    svg, img{
      max-width:22.5rem;
      max-height:22.5rem;
    }
  .col-2 svg,
  .col-2 img {
    margin: 5rem auto;
  }
.popup-image-container svg {
  display: block;
  margin-inline: auto;
}
`;
export const commonLHCOmponentStyle = (css) => css`
  :host {
    font-size: inherit;
    display: block;
    /*height: min(100%, var(--maxH));*/
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    outline: none !important
  }
`;
export const commonFormStyles = (css) => [
  buttons.all(css),
  inputs.all(css),
  css`
  :host{
  outline: none !important;
}
  /* Safari hacks */
  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) {
      div.date-wrapper > svg:first-child:not(.banner) {
        top: 2rem !important;
      }
      .with-validation div.date-wrapper svg.icon-calendar {
        top: 2rem !important;
      }
    }
  }
`];
export const commonExternalAgentMailsDesktopStyle = (css) => css`
  
  .send-mail-btn-div-grid {
    min-width: 20rem;
    display: grid;
  }

  .send-mail-btn-div img {
    max-width:2rem;
    margin-inline-end:0.5rem;
  }

  .send-mail-btn-div {
    display: flex;
    padding-block-start: 0.5rem;
    align-items: baseline;
  }

  .send-mail-btn-div.download-quote {
  flex-direction:column;
  }

  .send-mail-btn-div.download-quote img{
  max-width:2rem;
  margin-inline-end:0.5rem;
  }

  .buy-now.quote-btn {
    color: var(--c-emphasize-sec);
    border: none;
    background: none;
  }

  .buy-now {
    max-width: unset;
    width: 100%;
    /*white-space: normal;*/
    padding-block-start: 2rem;
    border-radius: 4.5rem;
    padding: 1.5rem;
    padding-inline-start: 0.25rem;
    margin-bottom: 0;
    height: max-content;
    line-height: 3rem;
    font-size: 2.25rem;
    font-weight: 700;
    cursor: pointer;
    place-items: center;
    place-content: center;
  }

  .buy-now img{
    height:3rem;
    opacity:0;
  }

  .buy-now[disabled], .buy-now[disabled]:hover {
    cursor: initial;
  }

  button.buy-now {
    display: flex; 
  }
  
  button.buy-now.with-side-arrow {  
    justify-content: space-between;
  }

`;
export const commonBillingDesktopStyle = (css) => css`
  :host {
    outline: none !important;
  }

  .content {
    position: fixed;
    padding: 2rem;
    background-color: #F8F8FB;
    box-shadow: 0px 3px 6px rgba(25, 72, 146, 0.06);
    border-radius: 10px;
  }

  @media screen and (min-width: 1460px) and (max-height: 800px) {
    .billing-container .send-mail-btn-div-grid {
      order: -1;
    }

    .billing-container .user-pay-btn.with-mail-btns {
      margin-top: 0;
    }
  }
`;
export const commonBillingMobileStyle = (css) => css`
   :host{
     outline: none !important
   }
`;
export const commonBillingStyle = (css) => css`
:host {
  width: 322px;
  height: 488px;
  outline: none !important
}

.container {
  position: relative;
  height: 100%;
  background: #F8F8FB;
  box-shadow: 0px 3px 6px rgba(25, 72, 146, 0.06);
  border-radius: 10px;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.line-text {
    align-items: center;
    display: flex;
    height: 6.25rem;
    min-width: 100%;
    flex-direction: row;
    place-content: space-around space-between;
}


.promotion-text {
  color: var(--c-text-description);
  font-weight: 500;
  font-size: 2rem;
  line-height: 2.75rem;
  min-height: 3rem;
  min-width: 9rem;
  letter-spacing: 0rem;
  text-align: left;
  display:flex;
  place-items:center start;
}

.promotion-text svg {
  max-width: 3rem;
  margin-inline-start: 0.5em;
}

.text-1 {
  color: var(--c-text);
  font-weight: 400;
  font-size: 2.5rem;
  text-align: right;
}

.discount {
  color: var(--c-emphasize);
  font-size: 2.5rem;
  text-align: right;
}

.processing-fee {
  font-size: 2.5rem;
  text-align: right;
}

button:disabled {
  background-color: var(--btn-disabled-color, white);
}

.total {
  color: var(--c-font-title);
  min-height: 3rem;
  min-width: 5rem;
}

.price {
  align-self: flex-end;
  color: var(--c-font-title);
  font-weight: bold;
  font-size: 2.5rem;
  text-align: center;
}

.price.billing-annual-message {
  font-size: 1.5rem;
  text-align: left;
}

.billing-annual-message.keep-color {
  color: rgba(18, 18, 19, 0.4);
}

.line-8 {
  width: 36.375rem;
}

#birdImg {
  max-width: 22.5rem;
}

.content h2 {
  font-weight: 500;
  font-size: 3.75rem;
  line-height: 4.5rem;
  color: var(--c-text-text);
}

.content p {
  font-size: 2rem;
  line-height: 3rem;
}

.content a {
  font-size: 2rem;
  line-height: 2.5rem;
}

a:link,
a:visited {
  color: #4C49C0;
  text-decoration: underline;
  cursor: pointer;
}

a:link:active,
a:visited:active {
  color: #4C49C0;
  cursor: pointer;
}
  
.billing-container {
  display: flex;
  flex-direction: column;
  /* align-items: center;*/
  padding-inline: 2rem;
}

.frame-3023 {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.frame-3021 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 36.375rem;
}

.line-85 {
  height: 1px;
  width: 36.375rem;
}

.button {
  align-items: flex-start;
  background-color: var(--disabled);
  border-radius: 60px;
  display: flex;
  height: 50px;
  justify-content: center;
  margin-right: 4.0px;
  margin-top: 30px;
  overflow: hidden;
  width: 165px;
  color: var(--input-fg);
}

.next {
  color: var(--white);
  font-weight: 500;
  min-height: 27px;
  min-width: 77px;
  text-align: center;
}

.payment-validation {
  font-weight: 500;
  font-size: 2rem;
  text-align: center;
  color: var(--c-err);
  margin-block-start: 2rem;
}

div.payment-validation.render-in-green {
  color: var(--c-success);
}

.each-payment-includes-5-handling-fee {
  font-weight: 500;
  font-size: 1.5rem;  
  text-align: left;
  color: rgba(18, 18, 19, 0.4);
  max-width: 50rem
}

button.user-pay-btn.with-mail-btns {width:100%;margin:0;margin-top:2rem}

button.user-pay-btn {
  font-size: 2.2rem;
  height: 6rem;
  display: flex;
  place-items: center;
  place-content: center;
  gap: 1rem;
  background-color: var(--c-emphasize-sec);
  border: var(--c-emphasize-sec);
  cursor: pointer;
  width: 50%;
  margin: 2rem;
  margin-bottom: 0;
  color: white;
  border-radius: 5rem;
}

button.user-pay-btn:disabled {
  background-color: var(--btn-disabled-color);
  color: var(--c-bg-sec);
  cursor: initial;
}

button.user-pay-btn:hover:not(:disabled) {
  background-color: var(--c-button-hover);
  border: 2px solid var(--c-button-hover);
}

button:hover {
  background-color: var(--c-button-hover);
  border: 2px solid var(--c-button-hover);
}

button[disabled]:hover {
  background-color: none;
  border: none;
}
`;
export const commonAnimationsStyle = (css) => css`
  :host{
    outline: none !important
  }
  .fade-in {
    visibility: visible;
    opacity: 1;
    height: 100%;
    transition: opacity 0.6s linear;
  }
  .fade-in.delay {
    transition: opacity 0.3s 0.6s linear;
  }
  .fade-out {
    visibility: hidden;
    opacity: 0;
    height: 0 !important;
    transition: visibility 0s 0.6s, opacity 0.6s linear, height 0s 0.6s ease;
  }
  button.fade-out {
    min-height: 0 !important;
  }
`;
export const commonFormDesktopStyles = css => [
  inputs.desktop(css),
  buttons.dekstop(css),
  css`
  :host{
    outline: none !important
  }
  #answer .button-bar {
    --btn-text-size: 2.5rem;
    --btn-note-text-size: 2rem;
    --button-bar-width: 100%;
  }
  #answer .button-bar button {
    width: max-content;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    padding: 1rem 2rem;
    text-align: start;
  }
  #answer .button-bar button img {
    display: block;
  }
`];

export const commonStyles = {
  base: {
    billing: commonBillingStyle,
  },
  mobile: {
    forms: commonFormStyles,
    popups: commonPopupStyle,
    component: commonLHCOmponentStyle,
    animations: commonAnimationsStyle,
    billing: commonBillingMobileStyle,
  },
  desktop: {
    // TODO: check for differences for desktop/mobile
    forms: commonFormDesktopStyles,
    popups: commonPopupDesktopStyle,
    component: commonLHCOmponentStyle,
    billing: commonBillingDesktopStyle,
    externalAgentMails: commonExternalAgentMailsDesktopStyle,
  },
};